import React, { useState } from "react";

const Navbar = ({ onLogout, isMobile, toggleSidebar }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Get logged-in user
  let user = {};

  try {
    user = JSON.parse(localStorage.getItem("user") || "{}");
  } catch (error) {
    user = {};
  }

  const userName = user?.name || user?.fullName || user?.username || "User";

  const rawRole =
    user?.role || user?.roleName || localStorage.getItem("userRole") || "";

  // Convert role to readable format
  const formatRole = (role) => {
    if (!role) return "";

    return role
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const roleName = formatRole(rawRole);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        height: "70px",
        padding: "0 22px",
        backgroundColor: "#a9bfcc",
        boxSizing: "border-box",

        position: "fixed",
        top: 0,
        left: 0,

        zIndex: 1000,
      }}
    >
      {/* ================= LEFT SIDE ================= */}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        {/* Mobile Sidebar Button */}
        {isMobile && (
          <button
            type="button"
            onClick={toggleSidebar}
            style={{
              border: "none",
              background: "transparent",
              color: "#252c78",
              fontSize: "24px",
              cursor: "pointer",
              padding: 0,
            }}
          >
            ☰
          </button>
        )}

        <div
          style={{
            fontSize: isMobile ? "17px" : "21px",
            fontWeight: "700",
            color: "#292d78",
            whiteSpace: "nowrap",
          }}
        >
          Softvolute Buildcon LLP
        </div>
      </div>

      {/* ================= DESKTOP RIGHT SIDE ================= */}

      {!isMobile && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          {/* Welcome User */}

          <div
            style={{
              color: "#ffffff",
              fontSize: "15px",
              fontWeight: "700",
              whiteSpace: "nowrap",
            }}
          >
            Welcome, {userName}
          </div>

          {/* Role Badge */}

          {roleName && (
            <div
              style={{
                backgroundColor: "#292d78",
                color: "#ffffff",
                padding: "8px 13px",
                borderRadius: "18px",
                fontSize: "12px",
                fontWeight: "700",
                whiteSpace: "nowrap",
              }}
            >
              {roleName}
            </div>
          )}

          {/* Logout */}

          <button
            type="button"
            onClick={onLogout}
            style={{
              backgroundColor: "#23868a",
              color: "#ffffff",
              border: "none",
              padding: "12px 24px",
              borderRadius: "24px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
              minWidth: "96px",
            }}
          >
            Logout
          </button>
        </div>
      )}

      {/* ================= MOBILE RIGHT SIDE ================= */}

      {isMobile && (
        <div>
          <button
            type="button"
            onClick={() => setIsMenuOpen((prev) => !prev)}
            style={{
              background: "transparent",
              border: "none",
              color: "#ffffff",
              fontSize: "24px",
              cursor: "pointer",
            }}
          >
            ⋮
          </button>

          {isMenuOpen && (
            <div
              style={{
                position: "absolute",
                right: "12px",
                top: "62px",
                width: "190px",
                padding: "12px",
                backgroundColor: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 5px 18px rgba(0,0,0,0.18)",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "700",
                  color: "#222",
                  marginBottom: "4px",
                }}
              >
                {userName}
              </div>

              {roleName && (
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginBottom: "12px",
                  }}
                >
                  {roleName}
                </div>
              )}

              <button
                type="button"
                onClick={() => {
                  setIsMenuOpen(false);
                  onLogout();
                }}
                style={{
                  width: "100%",
                  border: "none",
                  backgroundColor: "#23868a",
                  color: "#ffffff",
                  padding: "9px 12px",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Navbar;
